/* global ReactSpringserveComponent */

angular.module('vastdesk').component('aiHelpCenterDrawer', {
  template: require('../templates/aiHelpCenterDrawer.html'),
  bindings: {
    aiGatewayBaseUrl: '@',
    authToken: '@',
    contextId: '@',
  },
  controllerAs: '$aiHelpCenterDrawerCtrl',
  controller: [
    '$scope',
    function ($scope) {
      const self = this;

      this.rootId = `component-root-angular-AgentChatDrawer-${crypto.randomUUID()}`;

      this.open = false;
      this.unregisterWatcher = null;

      this.handleClose = () => {
        self.open = false;
        $scope.$apply();
      };

      this.openDrawer = () => {
        self.open = true;
        $scope.$apply();
      };

      this.renderReactComponent = () => {
        return window.reactComponentScriptLoaded.promise.then(() => {
          ReactSpringserveComponent.renderComponent({
            componentName: 'AgentChatDrawer',
            rootId: self.rootId,
            componentProps: {
              open: self.open,
              onClose: self.handleClose,
              aiGatewayBaseUrl: self.aiGatewayBaseUrl || '',
              authToken: self.authToken || '',
              contextId: self.contextId || '',
            },
          });
        });
      };

      this.$onInit = () => {
        self.renderReactComponent().then(() => {
          self.unregisterWatcher = $scope.$watch(
            '$aiHelpCenterDrawerCtrl.open',
            () => {
              self.renderReactComponent();
            }
          );
        });

        // Listen for clicks on the AI Help Desk link
        $(document).on('click', '#ai-help-center-trigger', function (e) {
          e.preventDefault();
          self.openDrawer();
        });
      };

      this.$onDestroy = () => {
        if (self.unregisterWatcher) {
          self.unregisterWatcher();
        }
        $(document).off('click', '#ai-help-center-trigger');
      };
    },
  ],
});
